import { VariantProps } from 'class-variance-authority';
import { ComponentPropsWithoutRef, FC } from 'react';
import { twMerge } from 'tailwind-merge';
import { styles } from './FeaturedIcon.styles';

export type FeaturedIconProps = {
  color?: VariantProps<typeof styles>['color'];
  size?: VariantProps<typeof styles>['size'];
  type?: VariantProps<typeof styles>['type'];
} & ComponentPropsWithoutRef<'span'>;

export const FeaturedIcon: FC<FeaturedIconProps> = ({ children, color = 'brand', size = 'md', type = 'light', className, ...rest }) => {
  return (
    <span className={twMerge(styles({ color, size, type }), className)} {...rest}>
      {children}
    </span>
  );
};
